<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content" style="">
      <!-- tab切换 -->
      <div class=" ">
        <el-tabs v-model="activeName" type="border-card">
          <el-tab-pane label="国内市场" name="first" :key="'first'" v-if="(!lkFlag) || adminFlag">
            <marketingReport v-if="activeName === 'first'" />
          </el-tab-pane>
          <el-tab-pane label="朗康" name="second" :key="'second'" v-if="lkFlag||adminFlag">
            <marketingReportLk v-if="activeName === 'second'" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import marketingReport from './marketingReport.vue'
import marketingReportLk from './marketingReportLk.vue'
export default {
  components: {
    //Breadcrumb,
    marketingReport,
    marketingReportLk
  },
  data() {
    return {
      // 默认第一个Tab
      activeName: "first",
      showLkTab: false,
      lkFlag:false,
      adminFlag:false,
    };

  },
  created() {
    if(this.$route.query.type){
      this.activeName = this.$route.query.type;
    }
    this.lkFlag = this.$store.getters.hasRole('swyl_xiaoshoujl_hh,langk_pingtai');
    this.adminFlag = this.$store.getters.hasRole('xtgly-new,swyl_admin');
  },
  methods: {
    //tab切换
    handleClick(tab) {
    },

  }
}
</script>
<style scoped>
.h-content{
  background: #fff
}
</style>
